(() => {
  const root = document.querySelector('[data-cart-experience]');
  const grid = root?.querySelector('[data-cart-saved-grid]');
  const empty = root?.querySelector('[data-cart-saved-empty]');
  if (!root || !grid || !empty) return;

  const storageKey = 'philistia-wishlist';
  const routeRoot = window.Shopify?.routes?.root || '/';
  const route = (path = '') => `${routeRoot.replace(/\/?$/, '/')}${String(path).replace(/^\/+/, '')}`;
  const escapeHTML = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[char]));
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
    style: 'currency', currency: document.body.dataset.currency || 'CAD'
  }).format(Number(cents || 0) / 100);

  const discountInput = root.querySelector('[data-discount-code]');
  const discountButton = root.querySelector('[data-discount-apply]');
  const discountStatus = root.querySelector('[data-discount-status]');
  const referralShare = root.querySelector('[data-referral-share]');

  const applyDiscount = () => {
    const code = discountInput?.value.trim();
    if (!code) {
      if (discountStatus) discountStatus.textContent = 'Enter a discount code first.';
      discountInput?.focus();
      return;
    }
    if (discountButton) {
      discountButton.disabled = true;
      discountButton.textContent = 'Applying…';
    }
    location.assign(`${route(`discount/${encodeURIComponent(code)}`)}?redirect=${encodeURIComponent(route('cart'))}`);
  };

  discountButton?.addEventListener('click', applyDiscount);
  discountInput?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      applyDiscount();
    }
  });

  if (referralShare) {
    const code = referralShare.dataset.code || '';
    const link = referralShare.dataset.link || '';
    const status = referralShare.querySelector('[data-referral-status]');
    const copied = (message) => { if (status) status.textContent = message; };
    referralShare.querySelector('[data-copy-referral]')?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(code);
        copied('Referral code copied.');
      } catch (_error) {
        referralShare.querySelector('input')?.select();
        copied('Select and copy the code above.');
      }
    });
    referralShare.querySelector('[data-share-referral]')?.addEventListener('click', async () => {
      const shareData = { title: 'Philistia Shop', text: `Use my Philistia referral code ${code}`, url: link };
      try {
        if (navigator.share) await navigator.share(shareData);
        else {
          await navigator.clipboard.writeText(link);
          copied('Invitation link copied.');
        }
      } catch (error) {
        if (error?.name !== 'AbortError') copied('Copy the referral code above to share it.');
      }
    });
  }

  const loadHandles = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string').slice(0, 12) : [];
    } catch (_error) { return []; }
  };

  const writeHandles = (handles) => {
    localStorage.setItem(storageKey, JSON.stringify(handles));
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => { count.textContent = handles.length; });
  };

  async function addSavedVariant(button) {
    const id = Number(button.dataset.savedAdd);
    if (!Number.isFinite(id) || id <= 0) return;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(route('cart/add.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('This piece could not be added right now.');
      location.assign(route('cart'));
    } catch (error) {
      button.disabled = false;
      button.textContent = original;
      alert(error.message);
    }
  }

  async function renderSaved() {
    const handles = loadHandles();
    if (!handles.length) {
      grid.setAttribute('aria-busy', 'false');
      empty.hidden = false;
      return;
    }
    const queriedHandles = handles.slice(0, 4);
    const products = (await Promise.all(queriedHandles.map((handle) => fetch(route(`products/${encodeURIComponent(handle)}.js`), {
      headers: { Accept: 'application/json' }
    }).then((response) => response.ok ? response.json() : null).catch(() => null)))).filter(Boolean);
    const valid = products.map((product) => product.handle);
    if (!products.length) {
      writeHandles([]);
      grid.setAttribute('aria-busy', 'false');
      empty.hidden = false;
      return;
    }
    if (valid.length !== queriedHandles.length) writeHandles(handles.filter((handle) => !queriedHandles.includes(handle) || valid.includes(handle)));
    grid.innerHTML = products.map((product, index) => {
      const variant = (product.variants || []).find((item) => item.available);
      return `<article class="cart-saved-card" style="--saved-delay:${index * 70}ms">
        <a href="${escapeHTML(product.url)}">${product.featured_image ? `<img src="${escapeHTML(product.featured_image)}" loading="lazy" alt="${escapeHTML(product.title)}">` : '<span class="wishlist-no-image">فلسطين</span>'}</a>
        <div><small>Saved piece</small><h3><a href="${escapeHTML(product.url)}">${escapeHTML(product.title)}</a></h3><strong>${escapeHTML(money(product.price))}</strong></div>
        <div class="cart-saved-card__actions">${variant ? `<button type="button" data-saved-add="${Number(variant.id)}">Add to Bag</button>` : '<span>Unavailable</span>'}<button type="button" data-saved-remove="${escapeHTML(product.handle)}">Remove</button></div>
      </article>`;
    }).join('');
    grid.setAttribute('aria-busy', 'false');
    empty.hidden = true;
    grid.querySelectorAll('[data-saved-add]').forEach((button) => button.addEventListener('click', () => addSavedVariant(button)));
    grid.querySelectorAll('[data-saved-remove]').forEach((button) => button.addEventListener('click', () => {
      writeHandles(loadHandles().filter((handle) => handle !== button.dataset.savedRemove));
      button.closest('.cart-saved-card')?.remove();
      if (!grid.querySelector('.cart-saved-card')) empty.hidden = false;
    }));
  }

  renderSaved();
})();
